import React from 'react';
const comparisonRows = [{
  without: 'Evitás conversaciones → acumulás resentimiento',
  with: 'Claridad → hablás lo que necesitás'
}, {
  without: 'Discutís por todo → desgaste emocional',
  with: 'Acuerdos claros → menos conflictos'
}, {
  without: 'No sabés qué decir → frustración',
  with: 'Guiones listos → comunicación efectiva'
}, {
  without: 'Todo sigue igual → desesperanza',
  with: 'Cambios reales → relación mejorada'
}];
export function ComparisonTableExtended() {
  return <section className="bg-brand-dark text-white py-5 px-5" data-id="element-77">
      <div className="max-w-xl mx-auto" data-id="element-78">
        <h3 className="text-base md:text-lg font-black text-white mb-4 flex items-center gap-2" data-id="element-79">
          📚 TABLA COMPARATIVA — FAMILIA ORGANIZADA
        </h3>

        {/* Column headers */}
        <div className="grid grid-cols-2 gap-3 mb-3" data-id="element-80">
          <div className="text-xs font-bold text-red-400 flex items-center gap-1" data-id="element-81">
            ❌ Sin sistema
          </div>
          <div className="text-xs font-bold text-green-400 flex items-center gap-1" data-id="element-82">
            ✅ Con sistema
          </div>
        </div>

        {/* Rows */}
        <div className="space-y-2" data-id="element-83">
          {comparisonRows.map((row, idx) => <div key={idx} className="grid grid-cols-2 gap-3 border-t border-gray-800/60 pt-3" data-id="element-84">
              <p className="text-xs text-gray-500 leading-relaxed" data-id="element-85">
                {row.without}
              </p>
              <p className="text-xs text-gray-300 leading-relaxed" data-id="element-86">
                {row.with}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}